module.exports = __webpack_public_path__ + "static/media/pic-contact.3b494005.webp";